module.exports = __webpack_public_path__ + "static/media/modern-gallery-3.bbdecc8f.jpg";